import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { Postcard } from '@zola/zola-ui/src/assets/images/icons';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

const DigitalMoreInfo = ({ onConfirm }) => (
  <div className={styles.container}>
    <CircleIcon image={Postcard} size={100} variant="cream" />
    <div className={styles.header}>Why go digital?</div>
    <div className={styles.content}>
      Digital save the dates are a quick, easy way to tell guests about your upcoming wedding. Like
      our paper save the dates, digital save the dates are designed with care by Zola artists -
      spread the word in style!
    </div>
    <div className={styles.header}>How it works</div>
    <div className={styles.content}>
      After customizing your digital card, share the link over text, email, or DM. Since
      you&lsquo;ll be the one sharing your save the date, you can be sure it won&lsquo;t end up in
      the spam folder.{' '}
      <span role="img" aria-label="raised hands">
        🙌
      </span>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={onConfirm}>Got It</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalMoreInfo);
